import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { NavLink } from "react-router-dom";
import { Ring_circle } from "../../helper/imageConstant";

const TermsaAndConditions = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <>
      <ImageSection name={"Terms and Conditions"} />
      <section className="relative p-4 my-5 lg:my-5 xl:pb-14 overflow-hidden fonts text-justify">
        <div className="lg:mx-20 xl:mx-24 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 gap-8">
            <p className="text-[#555555] text-base lg:text-base 3xl:text-lg font-normal">
              We are selling fabrics through online by www.vikasfashion.com
              website. Vikas Silk Mills also operated e-commerce portal. Vikas
              Silk Mills to make your shopping experience as safe and enjoyable
              as possible. Our company incorporated under the laws of India.
              When used of the Website for online products order you should be
              checked out on acceptance without modification of all the terms,
              conditions and notices. Our contained in these Terms as may be
              posted on the Website from time to time. If you want to ask us
              anything about these terms and conditions or have any comments on
              or about our website than{" "}
              <span className="underline">
                <NavLink
                  to="/contact-us"
                  onClick={scrollToTop}
                  className="cursor-pointer"
                >
                  contact us,
                </NavLink>
              </span>{" "}
              otherwise email our customer service team.
            </p>
            <p className="text-[#555555] text-base lg:text-base 3xl:text-lg font-normal">
              In using the service of Vanyacreation.com you are deemed to have
              accepted the terms and conditions listed below
            </p>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Intellectual property
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                The trade marks, logos and service marks displayed on our
                website are the registered and unregistered marks of Vikas Silk
                Mills. Our associates, our licensors are protected by Indian and
                international trade mark laws. Except in connection with placing
                an order for products or as required by applicable law, you may
                not use, reproduce, duplicate, copy, sell, resell, access, and
                modify them without our Permission.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Account Registration / Password / Security{" "}
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                If you use the Site than you are responsible for maintaining the
                privacy of Your Account and Password and for restricting access
                to your computer. Also you agree to accept responsibility for
                all activities that occur under Your Account or Password or any
                other breach of security. Also be ensuring that you exit from
                your account at the end of each session. Your Information is
                defined as any information you provide to us in the
                registration, buying or listing process through email. We will
                protect Your Information in accordance with our Privacy Policy.
                Vikas Silk Mills shall not be liable to any person for any loss
                or damage.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                You also agree to
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Vikas Silk Mills's registration form fills up by Provide true,
                accurate, current and complete information about yourself. Also
                maintain and promptly update the Registration Data to keep it
                true, accurate, current and complete. If you provide any
                information that is untrue, inaccurate, incomplete, or not
                current than Vikas Silk Mills has reasonable grounds to suspect
                that such information is not in accordance with the User
                Agreement. Vikas Silk Mills has the right to indefinitely
                suspend or terminate your membership and refuse to provide you
                with access to the Site.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Services Offered
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Vikas Silk Mills provides online products selling and products
                services through the Web Site. One such service enables users to
                purchase original products. Like a Digital Print sarees,
                Embellished Sarees, Multicolor Sarees from various fashion.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Privacy Policy & Security
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Our privacy policy sets out how we will use your information and
                can be found at Privacy and Security. The User hereby accepts,
                expresses and agrees that he has read and fully understands the
                Privacy Policy of Vikas Silk Mills’s Website. The user further
                accept that the terms and subjects of such Privacy Policy are
                acceptable to him. By using this Website, you accepted to the
                processing described and warrant that all data provided by you
                is accurate.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Prices
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                We endeavor to provide you products with the best prices.
                However, sometimes a price online does not match the price in a
                store. In our effort to be the lowest price provider in your
                particular geographic region, store pricing may sometimes take
                issue from online prices. Prices and availability are subject to
                change without notice.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Credit Card Details
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                You agree, understand and confirm that the credit card details
                provided by you will be correct and accurate for services on
                Vikas Silk Mills. You shall not use the credit card which is not
                lawfully owned by you. You must use your own credit card. You
                further agree and undertake to provide the correct and valid
                credit card details when making payment on Vikas Silk Mills.
                Your credit card information never gives Vikas Silk Mills. we
                just get pass, hold or fail message from our payment gateways.
                Vikas Silk Mills will not be liable for any credit card
                fraud.You agree, understand and confirm that the credit card
                details provided by you will be correct and accurate for
                services on Vikas Silk Mills. You shall not use the credit card
                which is not lawfully owned by you. You must use your own credit
                card. You further agree and undertake to provide the correct and
                valid credit card details when making payment on Vikas Silk
                Mills. Your credit card information never gives Vikas Silk
                Mills. we just get pass, hold or fail message from our payment
                gateways. Vikas Silk Mills will not be liable for any credit
                card fraud.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Declined Transactions / Fraudulent
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Vikas Silk Mills reserves the right to recover the cost of
                goods, collection charges and lawyers’ fees from persons using
                the Site fraudulently. Vikas Silk Mills reserves the right to
                initiate legal proceedings against such persons for fraudulent
                use of the Site and any other unlawful acts / omissions in
                breach of these terms and conditions.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Order Confirmation
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                We are willing to accept verbal orders instructions must be
                confirmed in writing or fax before any work is started. Once you
                place an order with us, you will receive written confirmation by
                e-mail or post that your order has been received and it is being
                processed.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Cancellations and Returns
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Under the distance selling regulations you have the legal right
                to cancel your order within 7 working days from the date of
                receipt of the goods if you send us a notice of cancellation in
                writing and return the goods to us in their original, unworn and
                unused condition. Vikas Silk Mills will retain the postage
                charges as they are included in the free delivery service we
                provide in the India.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Conditions for Customer Support Chat
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Vikas Silk Mills may suspend live support service at any time
                without notice. Vikas Silk Mills or its executives are not
                responsible for any delay caused in attending to or replying to
                the queries via chat. Any communication through chat may be
                stored by Vikas Silk Mills for our reference. Customer would not
                have the right to access this information at a later date. While
                chatting you may not put on any objectionable information i.e.
                unlawful, threatening, abusive, defamatory, obscene information.
                The chat room will not be used for selling of any products or
                advising on business opportunity or any other form of appeal.
                You may proceed further, and chat with our online customer care
                executive only if you agree to the above terms and conditions.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                You Agree and Confirm
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                That you will use the services provided by Vikas Silk Mills, its
                affiliates and contracted companies, for lawful purposes only
                and follow with all applicable laws and regulations while using
                the Site and transacting on the Site. You will provide authentic
                and true information in all instances where such information is
                requested of you. Vikas Silk Mills reserves the right to confirm
                and validate the information and other details provided by you
                at any point of time. If on confirmation your details are found
                not to be true, Vikas Silk Mills has the right in its sole
                discretion to reject the registration and suspend you from using
                the Services of Vikas Silk Mills. The address at which delivery
                of the product ordered by you is to be made will be correct and
                proper in all respects. That before placing an order you will
                check the product description carefully. By placing an order for
                a product you agree to be bound by the conditions of sale
                included in the item's description.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Cost Variation
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Quotations lapse after 30 days unless re-confirmed.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Timings
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Will be agreed by negotiation and are based on delivery of
                materials to timescale and, where appropriate, customer
                approvals.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Consequential Loss
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                In no circumstances whatsoever do we accept liability for
                consequential loss or damage resulting from error or delay
                however caused. Any liability is limited to the charges we would
                normally make.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Ownership
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                All designs, artwork, print and materials supplied by Vikas Silk
                Mills & associated companies shall remain in our ownership until
                the time when remittances for such supply are received in full.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Additional Tasks
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Any additional tasks undertaken, but not quoted for are
                chargeable.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Rescheduling
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Is subject to capacity.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Complaints
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                We operate a complaints handling procedure which we will use to
                try to resolve disputes when they first arise, please let us
                know if you have any complaints or comments.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Modification of Terms & Conditions of Service
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                Vikas Silk Mills may at any time modify the Terms & Conditions
                of Use of the site without any prior notification to you. You
                can access the latest version of the User Agreement at any given
                time on Vikas Silk Mills. You should regularly review the Terms
                & Conditions on Vikas Silk Mills. In the event the modified
                Terms & Conditions is not acceptable to you, you should
                discontinue using the service. However, if you continue to use
                the service you shall be deemed to have agreed to accept and
                follow by the modified Terms & Conditions of Use of this site.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Government Law and Jurisdiction
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                User Agreement shall be construed in accord with the applicable
                laws of India. The Courts shall have exclusive jurisdiction in
                any proceedings arising out of this agreement. Any dispute or
                difference either in interpretation or otherwise, of any terms
                of this User Agreement between the parties hereto, the same
                shall be referred to an independent arbitrator who will be
                appointed by Vikas Silk Mills and his decision shall be final
                and binding on the parties hereto.
              </p>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Disclaimer
              </h1>
              <p className="text-[#555555] text-sm lg:text-base font-normal space-y-4">
                The product is not restocked once sold out. No information
                regarding the presence of any Product in our stock will be
                guaranteed and we will alert you only when an item is sold out.
                We as a merchant shall be under no liability whatever in respect
                of any loss or damage arising directly or indirectly out of the
                decline of authorization for any Transaction. Account of the
                Cardholder having exceeded the preset limit mutually agreed by
                us with our assuming bank from time to time.
              </p>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute lg:bottom-[50%] lg:-right-[8%] xl:-right-[8%] 2xl:-right-[9%] 3xl:bottom-[50%] 3xl:-right-[8%]">
          <div className="lg:w-36 xl:w-44 2xl:w-60 3xl:w-64 h-full">
            <img src={Ring_circle} alt="" className="object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsaAndConditions;
